import { displayToast, initializeModals, sendAppsignalError } from "../modules/utils";

export default class Pagination {
  constructor(node) {
    this.element = node;
    this.paginationElement = this.element.querySelector(".js-pagination-element");
    this.paginationContentElement = this.element.querySelector(".js-pagination-body");

    this.initialize();
  }

  initialize() {
    this.fetchPaginatedContent(this.element.dataset.url);

    this.paginationElement.addEventListener("click", (e) => {
      e.preventDefault();

      if (e.target.classList.contains("pagination-link")) {
        const currentUrl = new URL(window.location);
        const targetUrl = new URL(e.target.href);

        // We grab current url params and set them to the new url
        currentUrl.searchParams.forEach((value, name) => {
          if (name === "page") return;
          targetUrl.searchParams.set(name, value);
        });

        this.element.dispatchEvent(
          new CustomEvent("pagination-link-clicked", {
            detail: {
              page: targetUrl.searchParams.get("page"),
            },
          })
        );

        this.fetchPaginatedContent(targetUrl);
      }
    });

    this.element.addEventListener("pagination-link-updated", () => {
      this.fetchPaginatedContent(this.element.dataset.url);
    });
  }

  fetchPaginatedContent(url) {
    this.element.classList.add("is-loading");

    fetch(url)
      .then((response) => {
        this.response = response;

        if (response.status === 200) {
          return response.json();
        }

        throw new Error("Something went wrong");
      })
      .then((data) => {
        const { entries, pagination } = data;

        this.paginationElement.innerHTML = pagination;
        this.paginationContentElement.innerHTML = entries;

        window.Beyuna.initClasses(this.paginationContentElement);
        initializeModals(this.paginationContentElement);
      })
      .catch((e) => {
        console.error(e);
        displayToast(this.element.dataset.errorMessage);
        sendAppsignalError(e, "Pagination", {
          response: this.response,
        });
      })
      .finally(() => {
        this.element.classList.remove("is-loading");
      });
  }
}
